import ntzTemplate from '@/store/modules/ntz-template/ntz-template'
import ntzTemplateCreate from '@/store/modules/ntz-template/ntz-template-create'
import ntzTemplateEdit from '@/store/modules/ntz-template/ntz-template-edit'
import ntzTemplateDelete from '@/store/modules/ntz-template/ntz-template-delete'

export default {
  ntzTemplate,
  ntzTemplateCreate,
  ntzTemplateEdit,
  ntzTemplateDelete,
}
